/* MTN-promo-code : code des réglages « Promotion en cours » (config dans window.mtnPromo, posée par layout/theme.liquid).
   Repris de Maison du Remontoir (assets/mdr-promo.js), adapté à la fiche Motance (sections/be-product.liquid).
   - Fin automatique à la fin du jour promo_end, heure de Paris : tout [data-mtn-promo] est retiré, les prix normaux reviennent,
     rien n'est appliqué (événement mtn:promo-off pour le bouton d'achat et l'ensemble de la fiche).
   - Code appliqué tout seul pendant la promotion, quelle que soit la page d'arrivée : on lit /cart.js et, si le code n'y est pas,
     un seul appel à /discount/CODE en arrière-plan par chargement de page (réussi ou non), sans recharger la page.
     Vérification au chargement, après chaque ajout au panier et à l'ouverture du tiroir ; le panier affiché est ensuite rafraîchi.
   - Code retiré par le client (croix de l'étiquette) : noté dans sessionStorage, il n'est plus remis pendant la visite.
   - Pastille de la fiche et de la barre collante : « −30 % avec le code CODE », puis « ✓ Code CODE appliqué : −X € »
     dès que le code est dans le panier (ou en cookie, panier vide). Montant recalculé au changement de variante.
   Version Google Merchant Center (2 nov. 2026, même correction que Maison du Remontoir) : ce script ne réécrit plus aucun prix.
   La fiche garde le prix du flux (variant.price) ; la remise du code n'apparaît qu'au panier et au paiement.
   - Code appliqué seulement quand le client le demande : clic sur une pastille bouton [data-mtn-pgmc] (fiche, barre collante,
     tiroir, page panier), arrivée avec ?discount=CODE (suffixe des annonces Google Shopping), ou lien /discount/CODE (cookie
     discount_code déjà posé). L'appel à /discount/CODE se fait en arrière-plan, sans quitter la page.
   - Pastilles bouton : état « off » (Appliquer le code), « on » (Code activé) ou « busy » (appel en cours), tenu à jour ici.
   Ancien fonctionnement, neutralisé en commentaire plus bas : code appliqué tout seul sur toute page d'arrivée, prix avec le code
   et montant de la pastille recalculés au changement de variante.
   Prix barré après activation (3 nov. 2026) : le prix remisé par le code ne s'affiche qu'après un clic du visiteur sur « Activer le
   code » (marqueur localStorage mtn_promo_clic) ET si le code est au panier. Alors : classe mtn-px-on sur <html>, window.mtnPx = true,
   événement mtn:px (la fiche recalcule son prix et son bouton), cartes [data-mtn-px] avec prix remisé et prix normal barré. Code arrivé
   autrement (lien ?discount=, cookie) : bandeau « activé » possible, prix normaux. Croix du code : marqueur effacé, prix normaux.
   Le HTML servi ne contient jamais de prix remisé : tout est calculé ici, dans le navigateur. */
(function () {
  var cfg = window.mtnPromo;
  if (!cfg || !cfg.code) return;

  var CODE = String(cfg.code).trim();
  var code = CODE.toLowerCase();
  var KEY = 'mtn-promo-applied';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var keep = 100 - (Number(cfg.percent) || 0);
  // Remise arrondie au centime inférieur, comme Shopify (179,99 € avec −30 % : remise 53,99 €, payé 126,00 €).
  function saving(price) { return Math.floor(price * (100 - keep) / 100); }

  // Fin de journée heure de Paris (CET ou CEST selon la date), en millisecondes UTC.
  function parisEnd(ymd) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd || '');
    if (!m) return NaN;
    var utc = Date.UTC(+m[1], +m[2] - 1, +m[3], 23, 59, 59, 999);
    var offset = 3600000;
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })
        .formatToParts(new Date(utc))
        .forEach(function (x) { p[x.type] = +x.value; });
      offset = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute) - Math.floor(utc / 60000) * 60000;
    } catch (e) {}
    return utc - offset;
  }

  function removeAll() {
    document.querySelectorAll('[data-mtn-promo]').forEach(function (el) { el.remove(); });
    // Prix normaux rendus à côté de la version promo (cartes de recherche) : on les montre.
    document.querySelectorAll('[data-mtn-promo-off]').forEach(function (el) { el.hidden = false; });
    try { document.dispatchEvent(new CustomEvent('mtn:promo-off')); } catch (e) {}
    if (typeof setPx === 'function') setPx(false);
  }

  // Montant au format de la boutique, centimes à zéro masqués (« 54 € », « 37,80 € »).
  function money(cents) {
    var theme = (typeof Theme !== 'undefined' && Theme) || window.Theme || {};
    var format = theme.moneyFormat || '{{amount_with_comma_separator}} €';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      var thousands = ',', decimal = '.', precision = /no_decimals/.test(key) ? 0 : 2;
      if (key === 'amount_with_comma_separator') { thousands = '.'; decimal = ','; }
      else if (key === 'amount_no_decimals_with_comma_separator') { thousands = '.'; }
      else if (key === 'amount_with_space_separator') { thousands = ' '; decimal = ','; }
      else if (key === 'amount_no_decimals_with_space_separator') { thousands = ' '; }
      else if (key === 'amount_with_period_and_space_separator') { thousands = ' '; }
      else if (key === 'amount_with_apostrophe_separator') { thousands = "'"; }
      var parts = (cents / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var frac = parts[1];
      if (frac && /^0+$/.test(frac)) frac = '';
      return frac ? whole + decimal + frac : whole;
    });
  }
  // Montant avec centimes, comme les prix de la fiche (« 126,00 € »).
  function money2(cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  // Date invalide ou passée : on coupe tout.
  if (!(Date.now() <= parisEnd(cfg.end))) {
    removeAll();
    return;
  }

  function readStore() {
    try { return sessionStorage.getItem(KEY); } catch (e) { return null; }
  }

  function writeStore(value) {
    try {
      if (value) sessionStorage.setItem(KEY, value);
      else sessionStorage.removeItem(KEY);
    } catch (e) {}
  }

  // « -code » : retiré par le client pendant cette visite, on ne le remet pas.
  function removed() {
    return readStore() === '-' + code;
  }

  // Arrivée avec ?discount=CODE (annonce Google Shopping, lien de campagne) : vaut une demande du client, même après un retrait.
  function inUrl() {
    var q = null;
    try { q = new URLSearchParams(location.search).get('discount'); } catch (e) {}
    return !!q && q.toLowerCase().split(',').some(function (c) { return c.trim() === code; });
  }
  if (inUrl()) writeStore(code);

  // Le client a demandé le code : clic sur une pastille ou lien (« code » en session), ou cookie posé par /discount/CODE.
  function wanted() {
    if (removed()) return false;
    return readStore() === code || inCookie();
  }

  function inCookie() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return false;
    var value = m[1];
    try { value = decodeURIComponent(value); } catch (e) {}
    return value.toLowerCase().split(',').some(function (c) { return c.trim() === code; });
  }

  function inCart(cart) {
    var list = (cart && cart.discount_codes) || [];
    return list.some(function (d) { return String(d.code).toLowerCase() === code && d.applicable !== false; });
  }

  // Prix barré après activation : marqueur posé seulement par le clic sur « Activer le code ».
  var MARK = 'mtn_promo_clic';
  function marked() { try { return localStorage.getItem(MARK) === '1'; } catch (e) { return false; } }
  function mark(v) { try { if (v) localStorage.setItem(MARK, '1'); else localStorage.removeItem(MARK); } catch (e) {} }
  // Code au panier : applicable, ou panier vide (Shopify le marque alors « non applicable » faute d'article).
  function codeActive(cart) {
    var list = (cart && cart.discount_codes) || [];
    return list.some(function (d) { return String(d.code).toLowerCase() === code && (d.applicable !== false || !cart.item_count); });
  }
  // Prix avec le code : remise arrondie au centime inférieur, comme Shopify (257,00 € : remise 77,10 €, payé 179,90 €).
  var pct = Number(cfg.percent) || 0;
  function withCode(cents) { return cents - Math.floor(cents * pct / 100); }
  window.mtnPromoWithCode = withCode;
  function pxCards() {
    // Cartes : élément prix [data-mtn-px="centimes"]. Avec le code : prix remisé inséré juste avant (classes data-mtn-px-class),
    // prix normal barré (mtn-px-was). Sans : retour à l'état servi par le thème.
    document.querySelectorAll('[data-mtn-px]').forEach(function (el) {
      var cents = parseInt(el.dataset.mtnPx, 10);
      if (!(cents > 0)) return;
      var prev = el.previousElementSibling;
      var has = !!(prev && prev.hasAttribute('data-mtn-px-new'));
      if (window.mtnPx) {
        var txt = money2(withCode(cents));
        if (!has) {
          prev = document.createElement('span');
          prev.setAttribute('data-mtn-px-new', '');
          prev.className = el.dataset.mtnPxClass || '';
          el.parentNode.insertBefore(prev, el);
        }
        if (prev.textContent !== txt) prev.textContent = txt;
        el.classList.add('mtn-px-was');
      } else {
        if (has) prev.remove();
        el.classList.remove('mtn-px-was');
      }
    });
  }
  function setPx(on) {
    on = !!on && pct > 0;
    var was = !!window.mtnPx;
    window.mtnPx = on;
    document.documentElement.classList.toggle('mtn-px-on', on);
    pxCards();
    if (was !== on) { try { document.dispatchEvent(new CustomEvent('mtn:px', { detail: { on: on } })); } catch (e) {} }
  }
  function pxFrom(cart) { setPx(marked() && codeActive(cart)); }
  // Contenu redessiné (tiroir, cartes chargées plus tard) : prix remisés remis en place.
  var pxRaf = 0;
  new MutationObserver(function () {
    if (!window.mtnPx || pxRaf) return;
    pxRaf = requestAnimationFrame(function () { pxRaf = 0; pxCards(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  // Pastilles bouton : « on » = code activé, « off » = à appliquer, « busy » = appel en cours.
  function paint(state) {
    document.querySelectorAll('[data-mtn-pgmc]').forEach(function (b) {
      if (b.dataset.state === state) return;
      b.dataset.state = state;
      if (state === 'on') b.setAttribute('aria-disabled', 'true');
      else b.removeAttribute('aria-disabled');
      if (b.children.length > 1) {
        if (state === 'on') { b.children[0].setAttribute('aria-hidden', 'true'); b.children[1].removeAttribute('aria-hidden'); }
        else { b.children[1].setAttribute('aria-hidden', 'true'); b.children[0].removeAttribute('aria-hidden'); }
      }
    });
  }

  // Appel à /discount/CODE ; redirect=/cart.js : Shopify renvoie le panier au lieu de la page d'accueil.
  function applyCode() {
    return fetch(root + 'discount/' + encodeURIComponent(CODE) + '?redirect=' + encodeURIComponent(root + 'cart.js'), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  /* GMC 2026-11-02 : ancienne pastille avec montant (« ✓ Code CODE appliqué : −X € »), neutralisée :
  var applied = false;
  function pills() {
    var block = document.querySelector('[data-mtn-promo-price]');
    var price = block ? parseInt(block.dataset.price, 10) : NaN;
    var off = price > 0 ? saving(price) : 0;
    var text = applied && off > 0
      // MTN DA 2026-10-30 : montant toujours avec centimes (« −54,00 € »), comme tous les prix de la boutique. Avant : money(off).
      ? '✓ Code ' + CODE + ' appliqué : −' + money2(off)
      : '−' + cfg.percent + ' % avec le code ' + CODE;
    document.querySelectorAll('[data-mtn-pill]').forEach(function (el) {
      if (el.textContent !== text) el.textContent = text;
      el.classList.toggle('is-applied', applied);
    });
  }
  */

  // Code demandé mais absent du panier : un appel à /discount/CODE, une seule fois par chargement de page.
  // Renvoie true quand un panier non vide vient de recevoir le code (affichage à rafraîchir).
  // Code pas demandé : rien n'est appliqué ; la pastille passe quand même à « activé » si le code est déjà au panier.
  var tried = false;
  function ensure() {
    return getCart()
      .then(function (cart) {
        pxFrom(cart);
        if (inCart(cart)) { paint('on'); return false; }
        if (!wanted()) { paint('off'); return false; }
        paint('on');
        if (tried) return false;
        // Panier vide, code déjà en cookie : Shopify l'ajoute de lui-même au premier article.
        if (!cart.item_count && inCookie()) return false;
        tried = true;
        return applyCode().then(function (after) { pxFrom(after); return after.item_count > 0 && inCart(after); });
      })
      .catch(function () { return false; });
  }

  // Clic sur une pastille « Appliquer le code » : appel en arrière-plan, la page reste, aucun prix de la fiche ne change.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mtn-pgmc]');
    if (!b) return;
    // Bandeau de la fiche (MTN fiche 2026-11-02) : seul son bouton « Activer le code » [data-mtn-pgmc-btn] applique le code.
    if (b.querySelector('[data-mtn-pgmc-btn]') && !e.target.closest('[data-mtn-pgmc-btn]')) return;
    e.preventDefault();
    if (b.dataset.state !== 'off') return;
    paint('busy');
    applyCode()
      .then(function (after) {
        writeStore(code);
        tried = true;
        mark(true);
        pxFrom(after);
        paint('on');
        if (after.item_count > 0) refreshCart();
      })
      .catch(function () { paint('off'); });
  });

  /* GMC 2026-11-02 : ancienne version, code appliqué à tous les visiteurs, neutralisée :
  function ensureAll() {
    if (removed()) return Promise.resolve(false);
    return getCart()
      .then(function (cart) {
        if (inCart(cart) || (!cart.item_count && inCookie())) { applied = true; pills(); }
        if (inCart(cart) || tried || removed()) return false;
        // Panier vide, code déjà en cookie : Shopify l'ajoute de lui-même au premier article.
        if (!cart.item_count && inCookie()) return false;
        tried = true;
        // redirect=/cart.js : Shopify renvoie le panier au lieu de la page d'accueil.
        return fetch(root + 'discount/' + encodeURIComponent(CODE) + '?redirect=' + encodeURIComponent(root + 'cart.js'), { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (after) {
            if (inCart(after) || (!after.item_count && inCookie())) { applied = true; pills(); }
            return after.item_count > 0 && inCart(after);
          });
      })
      .catch(function () { return false; });
  }
  */

  // Panier affiché : page panier remplacée par sa section fraîche, tiroir rafraîchi par l'événement du thème.
  function refreshCart() {
    var page = document.querySelector('cart-component');
    var section = page && page.closest('.shopify-section');
    if (section) {
      var id = section.id.replace(/^shopify-section-/, '');
      fetch(root + 'cart?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-component');
          if (fresh) page.replaceWith(fresh);
        })
        .catch(function () {});
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.dataset.sectionId) return;
    var sid = drawer.dataset.sectionId;
    Promise.all([
      fetch(root + '?sections=' + encodeURIComponent(sid), { credentials: 'same-origin' }).then(function (r) { return r.json(); }),
      getCart(),
    ])
      .then(function (res) {
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { resource: res[1], data: { source: 'mtn-promo', sections: res[0], itemCount: res[1].item_count } },
        }));
      })
      .catch(function () {});
  }

  function check() {
    ensure().then(function (changed) { if (changed) refreshCart(); });
  }

  check();

  /* GMC 2026-11-02 : prix avec le code recalculé au changement de variante, neutralisé (la fiche garde le prix normal) :
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'id' || !t.dataset || !t.dataset.price) return;
    var price = parseInt(t.dataset.price, 10);
    if (!(price > 0)) return;
    document.querySelectorAll('[data-mtn-promo-price]').forEach(function (block) {
      block.dataset.price = price;
      var now = block.querySelector('[data-mtn-now]');
      var was = block.querySelector('[data-mtn-was]');
      if (now) now.textContent = money2(price - saving(price));
      if (was) was.textContent = money2(price);
    });
    pills();
  });
  */

  // Ajout au panier (fiche, ajout rapide, ventes croisées…) : on vérifie le code. Nos propres rafraîchissements et ceux du champ
  // code sont ignorés ; le champ code nous dit seulement si le client a remis le code lui-même.
  document.addEventListener('cart:updated', function (e) {
    var source = e.detail && e.detail.data && e.detail.data.source;
    if (source === 'mtn-promo') return;
    if (source === 'cart-discount') {
      getCart().then(function (cart) {
        pxFrom(cart);
        if (inCart(cart)) { writeStore(code); paint('on'); } else paint(wanted() ? 'on' : 'off');
      }).catch(function () {});
      /* GMC 2026-11-02 : ancienne version :
      getCart().then(function (cart) {
        applied = inCart(cart);
        pills();
        if (applied) writeStore('');
      }).catch(function () {});
      */
      return;
    }
    check();
  });

  // Ouverture du tiroir panier.
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var open = drawer.classList.contains('is-open');
    new MutationObserver(function () {
      var now = drawer.classList.contains('is-open');
      if (now && !open) check();
      open = now;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();

  // Croix de l'étiquette du code (tiroir ou page panier) : noté avant que le thème ne retire le code (et recharge la page panier).
  document.addEventListener('click', function (e) {
    var cross = e.target.closest && e.target.closest('[data-ref="remove-discount"]');
    var badge = cross && cross.closest('[data-ref="discount-badge"]');
    if (badge && String(badge.dataset.discountCode).toLowerCase() === code) {
      writeStore('-' + code);
      mark(false);
      setPx(false);
      paint('off');
    }
  }, true);
})();
